module.exports = __webpack_public_path__ + "static/media/teltplass.aa9c12fc.png";